import formInput from '@/components/common/form-input/form-input.vue'
import formSelect from '@/components/common/form-select/form-select.vue'
import formButton from '@/components/common/form-button/form-button.vue'
import { mapState } from 'vuex'

export default {
  components: {
    formInput,
    formSelect,
    formButton
  },
  data() {
    return {
      user: {}
    }
  },
  computed: {
    ...mapState('user', ['currentUser'])
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/main-pages/user-profile/user-profile.js